import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import { useModelStore } from "../../store/useModelStore";
import { useRouterStore } from "../../store/useRouterStore";
import { SafariDialog, SimpleBox } from "../MaterialCustomComponents";
import CloseIcon from "@mui/icons-material/Close";

const SafariVideoComponent = () => {
  const {
    isSafariBrowser,
    isVideoClicked,
    setIsVideoClicked,
    setIsSingleBoothViewButtonPressed,
  } = useComponentLoadingStateStore();
  const { booths } = useModelStore();
  const { boothID } = useRouterStore();
  const [selectedVideo, setSelectedVideo] = useState(
    "BUILDING SOLUTIONS (LIST)"
  );
  const [videoURL, setVideoURL] = useState("");
  const [videos, setVideos] = useState([]);
  const [open, setOpen] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    if (isSafariBrowser && isVideoClicked) {
      setOpen(true);
      setIsSingleBoothViewButtonPressed(false);
    }
    getBoothVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boothID, isSafariBrowser, isVideoClicked]);

  const getBoothVideos = () => {
    booths?.forEach((booth) => {
      if (booth.name === boothID) {
        setVideos(booth.data.video);
        setVideoURL(booth.data.video[0].url);
        setSelectedVideo(booth.data.video[0].title);
      }
    });
  };

  const handleChange = (e: any) => {
    setSelectedVideo(e.target.value);
  };

  const changeVideoURL = (url: string) => {
    if (!url) return;
    setVideoURL(url);
  };

  const handleClose = () => {
    setOpen(false);
    setIsVideoClicked(false);
    setIsSingleBoothViewButtonPressed(true);
  };

  return (
    <SafariDialog maxWidth="xl" onClose={handleClose} open={open}>
      <DialogTitle sx={{ fontSize: "1rem" }}>
        BUILDING SOLUTIONS (LIST)
      </DialogTitle>
      <CloseIcon
        sx={{
          position: "absolute",
          right: "10px",
          top: "20px",
          cursor: "pointer",
        }}
        onClick={handleClose}
      />
      {width >= 1000 ? (
        <video
          src={videoURL}
          controls
          autoPlay
          width={900}
          height={500}
        ></video>
      ) : (
        <>
          <video
            src={videoURL}
            controls
            autoPlay
            style={{ width: "100%", height: "100%" }}
          ></video>
          <SimpleBox sx={{ width: width }}></SimpleBox>
        </>
      )}
      <FormControl sx={{ marginTop: "2rem" }}>
        <InputLabel id="demo-simple-select-label">
          BUILDING SOLUTIONS (LIST)
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedVideo}
          label="BUILDING SOLUTIONS (LIST)"
          onChange={handleChange}
        >
          {videos?.map(({ title, url }) => (
            <MenuItem
              value={title}
              key={title}
              onClick={() => changeVideoURL(url)}
            >
              {title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </SafariDialog>
  );
};

export default SafariVideoComponent;
